/* eslint-disable no-unused-vars */
import React from 'react';
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Toast } from 'react-bootstrap';
import Masonry from 'react-masonry-component';

var getParams = function (url) {
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
};

const masonryOptions = {
    transitionDuration: 300
};

const imagesLoadedOptions = { backgroundColor: '#ddd', opacity: 0 }

class MasonryData extends React.Component {
    constructor(props) {
        super();
        this.state = {
            apiUrl: window.$apiUrl,
            alertBox: false,
            PopulatedData: props.PopulatedData
        };
        this.like = this.like.bind(this);
        this.liked = this.liked.bind(this);
        this.addDefaultSrc = this.addDefaultSrc.bind(this);
        this.toggleAlertBox = this.toggleAlertBox.bind(this);
    }

    toggleAlertBox() {
        this.setState({ alertBox: !this.state.alertBox });
    }

    addDefaultSrc(ev) {
        ev.target.src = './images/noimg.png';
    }

    like(e, sid) {
        e.target.src = "./images/heart.png";
        var likeCount = localStorage.getItem('lcount') ? JSON.parse(localStorage.getItem('lcount')) : [];
        var likeShowCount = localStorage.getItem('lshowcount') ? JSON.parse(localStorage.getItem('lshowcount')) : [];
        fetch(this.state.apiUrl + '/CommonAPI/SubmitLike', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify(
                {
                    "Story_ID": sid
                }
            )
        })
            .then(res => res.json())
            .then((data) => {
                likeCount.push(sid);
                likeShowCount.push(sid);
                this.setState({ alertBox: true });
                localStorage.setItem('lcount', JSON.stringify(likeCount));
                localStorage.setItem('lshowcount', JSON.stringify(likeShowCount));
            })
            .catch(console.log);
    }

    liked(e, sid) {
        var likedList = JSON.parse(localStorage.getItem('lshowcount'));
        var index = likedList.indexOf(sid);
        //likedList.splice(likedList.indexOf(sid), 1);

        if (e.target.src.includes('heart.png')) {
            e.target.src = "./images/heart_outline.png";
            if (index > -1) {
                likedList.splice(index, 1);
            }
            localStorage.setItem('lshowcount', JSON.stringify(likedList));
        } else {
            e.target.src = "./images/heart.png";
            likedList.push(sid);
            localStorage.setItem('lshowcount', JSON.stringify(likedList));
            //this.toggleWarningBox();
        }
    }

    render() {

        let likeArray = localStorage.getItem('lshowcount') ? localStorage.getItem('lshowcount') : [];
        return (
            <div className="row">
                <div className="col-md-12 container-masonry">
                    <Masonry
                        className={'masonry'}
                        options={masonryOptions}
                        disableImagesLoaded={false}
                        updateOnEachImageLoad={false}
                        imagesLoadedOptions={imagesLoadedOptions}
                    >
                        {this.state.PopulatedData.map((data, index) => {

                            return (
                                <div className="masonry_items" key={index}>
                                    <div className="position-relative overflow-hidden">
                                        <Link to={`/StoryDetails/${data.Story_ID}`}><img src={data.Story_Image} className="img-fluid w-100" alt={data.Story_Title} onError={this.addDefaultSrc} /></Link>
                                        <div className="position-absolute masonry-item-tag">
                                            {data.Challenge_Status} Challenge
                                            </div>
                                        <div className="position-absolute" style={{ right: '5px', top: '5px' }}>
                                            {!likeArray.includes(data.Story_ID) && <div className="position-absolute" style={{ right: '5px', top: '5px' }}>
                                                <img onClick={(e) => this.like(e, data.Story_ID)} src="images/heart_outline.png" className="icons-md cursor_pointer" />
                                            </div>}
                                            {likeArray.includes(data.Story_ID) && <div className="position-absolute" style={{ right: '5px', top: '5px' }}>
                                                <img src="images/heart.png" onClick={(e) => this.liked(e, data.Story_ID)} className="icons-md cursor_pointer" />
                                            </div>}
                                        </div>
                                    </div>
                                    <div className="masonry-item-details d-flex flex-row align-items-center p-1 p-md-2 position-relative">
                                        <div className="map-tag mr-2">
                                            <img src={data.Country_Icon} className="icons-sm" />
                                        </div>
                                        <div className="story-name text-truncate">
                                            {data.Story_Title}
                                        </div>

                                    </div>
                                </div>

                            );


                        })

                        }
                    </Masonry>
                </div>
                <Toast className="position-fixed" style={{ top: 0, left: '50%', transform: 'translate(-50%, 0)', zIndex: 999 }} onClose={this.toggleAlertBox} show={this.state.alertBox} animation={true} delay={2000} autohide>
                    <Toast.Header>
                        Thanks for your support!
                </Toast.Header>
                    <Toast.Body>
                        <img src="./images/checked.png" className="icons-md" /> You have liked a story!
                </Toast.Body>
                </Toast>
            </div >

        );
    }
}

export default MasonryData;

